const DEVICE_KEY = 'plume.deviceId';

/** Stable per-install id so ABS groups sessions from this device together. */
export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = `plume-${crypto.randomUUID()}`;
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return 'plume-ephemeral';
  }
}

export const platform = (() => {
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const iPadOs = typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || iPadOs;
  const isAndroid = /Android/i.test(ua);
  const isStandalone =
    typeof window !== 'undefined' &&
    (window.matchMedia?.('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true);
  return { isIOS, isAndroid, isStandalone };
})();
